export enum AccountRestrictionType {
	SEND_MONEY_TO_ANY_ACCOUNT = 1,
	SEND_MONEY_TO_SPECIFIC_ACCOUNTS = 2,
	CANNOT_SEND_MONEY = 3,
}
